module.exports = __webpack_public_path__ + "img/header-icon.1ecc3d09.png";